/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @interface PersonLegacy
 */
export interface PersonLegacyOptional {
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  parentEmail?: string;
  /**
   *
   * @type {number}
   * @memberof PersonLegacy
   */
  incomeLevel?: number;
  /**
   *
   * @type {number}
   * @memberof PersonLegacy
   */
  incomeAmt?: number;
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  incomeAmtRaw?: string;
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  badMail?: string;
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  deceased?: string;
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  doNotCall?: string;
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  doNotEmail?: string;
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  doNotMail?: string;
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  employer?: string;
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  referralSource?: string;
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  badPhone?: string;
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  badEmail?: string;
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  referralOther?: string;
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  jpAgeOverride?: string;
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  sendAlert?: string;
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  ignoreJpMinAge?: string;
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  uapInterestedLessons?: string;
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  uapInterestedRides?: string;
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  entityType?: string;
  /**
   *
   * @type {number}
   * @memberof PersonLegacy
   */
  jpTeamId?: number;
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  guestPortalReg?: string;
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  signoutBlockReason?: string;
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  campFair?: string;
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  dataUnconfirmed?: string;
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  protopersonCookie?: string;
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  protoState?: string;
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  memberComment?: string;
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  slackUserId?: string;
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  squareCustomerId?: string;
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  defaultCardId?: string;
}

export interface PersonLegacy extends PersonLegacyOptional {
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  parentEmail?: string;
  /**
   *
   * @type {number}
   * @memberof PersonLegacy
   */
  incomeLevel?: number;
  /**
   *
   * @type {number}
   * @memberof PersonLegacy
   */
  incomeAmt?: number;
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  incomeAmtRaw?: string;
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  badMail?: string;
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  deceased?: string;
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  doNotCall?: string;
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  doNotEmail?: string;
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  doNotMail?: string;
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  employer?: string;
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  referralSource?: string;
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  badPhone?: string;
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  badEmail?: string;
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  referralOther?: string;
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  jpAgeOverride?: string;
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  sendAlert?: string;
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  ignoreJpMinAge?: string;
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  uapInterestedLessons?: string;
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  uapInterestedRides?: string;
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  entityType?: string;
  /**
   *
   * @type {number}
   * @memberof PersonLegacy
   */
  jpTeamId?: number;
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  guestPortalReg?: string;
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  signoutBlockReason?: string;
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  campFair?: string;
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  dataUnconfirmed?: string;
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  protopersonCookie?: string;
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  protoState?: string;
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  memberComment?: string;
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  slackUserId?: string;
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  squareCustomerId?: string;
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  defaultCardId?: string;
}

export interface PersonLegacyTrackedI {
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  parentEmail?: string;
  parentEmailIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof PersonLegacy
   */
  incomeLevel?: number;
  incomeLevelIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof PersonLegacy
   */
  incomeAmt?: number;
  incomeAmtIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  incomeAmtRaw?: string;
  incomeAmtRawIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  badMail?: string;
  badMailIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  deceased?: string;
  deceasedIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  doNotCall?: string;
  doNotCallIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  doNotEmail?: string;
  doNotEmailIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  doNotMail?: string;
  doNotMailIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  employer?: string;
  employerIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  referralSource?: string;
  referralSourceIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  badPhone?: string;
  badPhoneIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  badEmail?: string;
  badEmailIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  referralOther?: string;
  referralOtherIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  jpAgeOverride?: string;
  jpAgeOverrideIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  sendAlert?: string;
  sendAlertIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  ignoreJpMinAge?: string;
  ignoreJpMinAgeIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  uapInterestedLessons?: string;
  uapInterestedLessonsIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  uapInterestedRides?: string;
  uapInterestedRidesIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  entityType?: string;
  entityTypeIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof PersonLegacy
   */
  jpTeamId?: number;
  jpTeamIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  guestPortalReg?: string;
  guestPortalRegIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  signoutBlockReason?: string;
  signoutBlockReasonIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  campFair?: string;
  campFairIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  dataUnconfirmed?: string;
  dataUnconfirmedIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  protopersonCookie?: string;
  protopersonCookieIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  protoState?: string;
  protoStateIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  memberComment?: string;
  memberCommentIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  slackUserId?: string;
  slackUserIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  squareCustomerId?: string;
  squareCustomerIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonLegacy
   */
  defaultCardId?: string;
  defaultCardIdIsSet: boolean;
}

transformDatesMap.set("PersonLegacy", function (model: PersonLegacy) {});

export type PersonLegacyMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  parentEmail: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  incomeLevel: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  incomeAmt: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  incomeAmtRaw: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  badMail: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  deceased: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  doNotCall: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  doNotEmail: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  doNotMail: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  employer: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  referralSource: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  badPhone: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  badEmail: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  referralOther: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  jpAgeOverride: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  sendAlert: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  ignoreJpMinAge: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  uapInterestedLessons: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  uapInterestedRides: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  entityType: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  jpTeamId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  guestPortalReg: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  signoutBlockReason: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  campFair: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  dataUnconfirmed: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  protopersonCookie: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  protoState: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  memberComment: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  slackUserId: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  squareCustomerId: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  defaultCardId: PropertyMeta<MetaTypeBase<string>>;
}>;

export var PersonLegacyMeta: PersonLegacyMetaI = {} as PersonLegacyMetaI;
PersonLegacyMeta = typeMeta("PersonLegacy", {
  parentEmail: propertyMeta(
    "parentEmail",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  incomeLevel: propertyMeta(
    "incomeLevel",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  incomeAmt: propertyMeta(
    "incomeAmt",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  incomeAmtRaw: propertyMeta(
    "incomeAmtRaw",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  badMail: propertyMeta("badMail", false, false, false, MetaTypesBase.string),
  deceased: propertyMeta("deceased", false, false, false, MetaTypesBase.string),
  doNotCall: propertyMeta(
    "doNotCall",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  doNotEmail: propertyMeta(
    "doNotEmail",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  doNotMail: propertyMeta(
    "doNotMail",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  employer: propertyMeta("employer", false, false, false, MetaTypesBase.string),
  referralSource: propertyMeta(
    "referralSource",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  badPhone: propertyMeta("badPhone", false, false, false, MetaTypesBase.string),
  badEmail: propertyMeta("badEmail", false, false, false, MetaTypesBase.string),
  referralOther: propertyMeta(
    "referralOther",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  jpAgeOverride: propertyMeta(
    "jpAgeOverride",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  sendAlert: propertyMeta(
    "sendAlert",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  ignoreJpMinAge: propertyMeta(
    "ignoreJpMinAge",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  uapInterestedLessons: propertyMeta(
    "uapInterestedLessons",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  uapInterestedRides: propertyMeta(
    "uapInterestedRides",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  entityType: propertyMeta(
    "entityType",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  jpTeamId: propertyMeta("jpTeamId", false, false, false, MetaTypesBase.number),
  guestPortalReg: propertyMeta(
    "guestPortalReg",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  signoutBlockReason: propertyMeta(
    "signoutBlockReason",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  campFair: propertyMeta("campFair", false, false, false, MetaTypesBase.string),
  dataUnconfirmed: propertyMeta(
    "dataUnconfirmed",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  protopersonCookie: propertyMeta(
    "protopersonCookie",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  protoState: propertyMeta(
    "protoState",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  memberComment: propertyMeta(
    "memberComment",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  slackUserId: propertyMeta(
    "slackUserId",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  squareCustomerId: propertyMeta(
    "squareCustomerId",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  defaultCardId: propertyMeta(
    "defaultCardId",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
});

const metaI = PersonLegacyMeta;

registerMeta(() => {});

export class PersonLegacyTracked implements PersonLegacyTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  parentEmail__I?: string = undefined;
  parentEmailIsSet: boolean = false;
  set parentEmail(v: undefined | string) {
    if (v !== undefined) {
      this.parentEmail__I = v;
      this.parentEmailIsSet = true;
    } else {
      this.parentEmail__I = v || undefined;
      this.parentEmailIsSet = false;
    }
    this.changeTracker = true;
  }
  get parentEmail() {
    return this.parentEmail__I;
  }
  incomeLevel__I?: number = undefined;
  incomeLevelIsSet: boolean = false;
  set incomeLevel(v: undefined | number) {
    if (v !== undefined) {
      this.incomeLevel__I = v;
      this.incomeLevelIsSet = true;
    } else {
      this.incomeLevel__I = v || undefined;
      this.incomeLevelIsSet = false;
    }
    this.changeTracker = true;
  }
  get incomeLevel() {
    return this.incomeLevel__I;
  }
  incomeAmt__I?: number = undefined;
  incomeAmtIsSet: boolean = false;
  set incomeAmt(v: undefined | number) {
    if (v !== undefined) {
      this.incomeAmt__I = v;
      this.incomeAmtIsSet = true;
    } else {
      this.incomeAmt__I = v || undefined;
      this.incomeAmtIsSet = false;
    }
    this.changeTracker = true;
  }
  get incomeAmt() {
    return this.incomeAmt__I;
  }
  incomeAmtRaw__I?: string = undefined;
  incomeAmtRawIsSet: boolean = false;
  set incomeAmtRaw(v: undefined | string) {
    if (v !== undefined) {
      this.incomeAmtRaw__I = v;
      this.incomeAmtRawIsSet = true;
    } else {
      this.incomeAmtRaw__I = v || undefined;
      this.incomeAmtRawIsSet = false;
    }
    this.changeTracker = true;
  }
  get incomeAmtRaw() {
    return this.incomeAmtRaw__I;
  }
  badMail__I?: string = undefined;
  badMailIsSet: boolean = false;
  set badMail(v: undefined | string) {
    if (v !== undefined) {
      this.badMail__I = v;
      this.badMailIsSet = true;
    } else {
      this.badMail__I = v || undefined;
      this.badMailIsSet = false;
    }
    this.changeTracker = true;
  }
  get badMail() {
    return this.badMail__I;
  }
  deceased__I?: string = undefined;
  deceasedIsSet: boolean = false;
  set deceased(v: undefined | string) {
    if (v !== undefined) {
      this.deceased__I = v;
      this.deceasedIsSet = true;
    } else {
      this.deceased__I = v || undefined;
      this.deceasedIsSet = false;
    }
    this.changeTracker = true;
  }
  get deceased() {
    return this.deceased__I;
  }
  doNotCall__I?: string = undefined;
  doNotCallIsSet: boolean = false;
  set doNotCall(v: undefined | string) {
    if (v !== undefined) {
      this.doNotCall__I = v;
      this.doNotCallIsSet = true;
    } else {
      this.doNotCall__I = v || undefined;
      this.doNotCallIsSet = false;
    }
    this.changeTracker = true;
  }
  get doNotCall() {
    return this.doNotCall__I;
  }
  doNotEmail__I?: string = undefined;
  doNotEmailIsSet: boolean = false;
  set doNotEmail(v: undefined | string) {
    if (v !== undefined) {
      this.doNotEmail__I = v;
      this.doNotEmailIsSet = true;
    } else {
      this.doNotEmail__I = v || undefined;
      this.doNotEmailIsSet = false;
    }
    this.changeTracker = true;
  }
  get doNotEmail() {
    return this.doNotEmail__I;
  }
  doNotMail__I?: string = undefined;
  doNotMailIsSet: boolean = false;
  set doNotMail(v: undefined | string) {
    if (v !== undefined) {
      this.doNotMail__I = v;
      this.doNotMailIsSet = true;
    } else {
      this.doNotMail__I = v || undefined;
      this.doNotMailIsSet = false;
    }
    this.changeTracker = true;
  }
  get doNotMail() {
    return this.doNotMail__I;
  }
  employer__I?: string = undefined;
  employerIsSet: boolean = false;
  set employer(v: undefined | string) {
    if (v !== undefined) {
      this.employer__I = v;
      this.employerIsSet = true;
    } else {
      this.employer__I = v || undefined;
      this.employerIsSet = false;
    }
    this.changeTracker = true;
  }
  get employer() {
    return this.employer__I;
  }
  referralSource__I?: string = undefined;
  referralSourceIsSet: boolean = false;
  set referralSource(v: undefined | string) {
    if (v !== undefined) {
      this.referralSource__I = v;
      this.referralSourceIsSet = true;
    } else {
      this.referralSource__I = v || undefined;
      this.referralSourceIsSet = false;
    }
    this.changeTracker = true;
  }
  get referralSource() {
    return this.referralSource__I;
  }
  badPhone__I?: string = undefined;
  badPhoneIsSet: boolean = false;
  set badPhone(v: undefined | string) {
    if (v !== undefined) {
      this.badPhone__I = v;
      this.badPhoneIsSet = true;
    } else {
      this.badPhone__I = v || undefined;
      this.badPhoneIsSet = false;
    }
    this.changeTracker = true;
  }
  get badPhone() {
    return this.badPhone__I;
  }
  badEmail__I?: string = undefined;
  badEmailIsSet: boolean = false;
  set badEmail(v: undefined | string) {
    if (v !== undefined) {
      this.badEmail__I = v;
      this.badEmailIsSet = true;
    } else {
      this.badEmail__I = v || undefined;
      this.badEmailIsSet = false;
    }
    this.changeTracker = true;
  }
  get badEmail() {
    return this.badEmail__I;
  }
  referralOther__I?: string = undefined;
  referralOtherIsSet: boolean = false;
  set referralOther(v: undefined | string) {
    if (v !== undefined) {
      this.referralOther__I = v;
      this.referralOtherIsSet = true;
    } else {
      this.referralOther__I = v || undefined;
      this.referralOtherIsSet = false;
    }
    this.changeTracker = true;
  }
  get referralOther() {
    return this.referralOther__I;
  }
  jpAgeOverride__I?: string = undefined;
  jpAgeOverrideIsSet: boolean = false;
  set jpAgeOverride(v: undefined | string) {
    if (v !== undefined) {
      this.jpAgeOverride__I = v;
      this.jpAgeOverrideIsSet = true;
    } else {
      this.jpAgeOverride__I = v || undefined;
      this.jpAgeOverrideIsSet = false;
    }
    this.changeTracker = true;
  }
  get jpAgeOverride() {
    return this.jpAgeOverride__I;
  }
  sendAlert__I?: string = undefined;
  sendAlertIsSet: boolean = false;
  set sendAlert(v: undefined | string) {
    if (v !== undefined) {
      this.sendAlert__I = v;
      this.sendAlertIsSet = true;
    } else {
      this.sendAlert__I = v || undefined;
      this.sendAlertIsSet = false;
    }
    this.changeTracker = true;
  }
  get sendAlert() {
    return this.sendAlert__I;
  }
  ignoreJpMinAge__I?: string = undefined;
  ignoreJpMinAgeIsSet: boolean = false;
  set ignoreJpMinAge(v: undefined | string) {
    if (v !== undefined) {
      this.ignoreJpMinAge__I = v;
      this.ignoreJpMinAgeIsSet = true;
    } else {
      this.ignoreJpMinAge__I = v || undefined;
      this.ignoreJpMinAgeIsSet = false;
    }
    this.changeTracker = true;
  }
  get ignoreJpMinAge() {
    return this.ignoreJpMinAge__I;
  }
  uapInterestedLessons__I?: string = undefined;
  uapInterestedLessonsIsSet: boolean = false;
  set uapInterestedLessons(v: undefined | string) {
    if (v !== undefined) {
      this.uapInterestedLessons__I = v;
      this.uapInterestedLessonsIsSet = true;
    } else {
      this.uapInterestedLessons__I = v || undefined;
      this.uapInterestedLessonsIsSet = false;
    }
    this.changeTracker = true;
  }
  get uapInterestedLessons() {
    return this.uapInterestedLessons__I;
  }
  uapInterestedRides__I?: string = undefined;
  uapInterestedRidesIsSet: boolean = false;
  set uapInterestedRides(v: undefined | string) {
    if (v !== undefined) {
      this.uapInterestedRides__I = v;
      this.uapInterestedRidesIsSet = true;
    } else {
      this.uapInterestedRides__I = v || undefined;
      this.uapInterestedRidesIsSet = false;
    }
    this.changeTracker = true;
  }
  get uapInterestedRides() {
    return this.uapInterestedRides__I;
  }
  entityType__I?: string = undefined;
  entityTypeIsSet: boolean = false;
  set entityType(v: undefined | string) {
    if (v !== undefined) {
      this.entityType__I = v;
      this.entityTypeIsSet = true;
    } else {
      this.entityType__I = v || undefined;
      this.entityTypeIsSet = false;
    }
    this.changeTracker = true;
  }
  get entityType() {
    return this.entityType__I;
  }
  jpTeamId__I?: number = undefined;
  jpTeamIdIsSet: boolean = false;
  set jpTeamId(v: undefined | number) {
    if (v !== undefined) {
      this.jpTeamId__I = v;
      this.jpTeamIdIsSet = true;
    } else {
      this.jpTeamId__I = v || undefined;
      this.jpTeamIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get jpTeamId() {
    return this.jpTeamId__I;
  }
  guestPortalReg__I?: string = undefined;
  guestPortalRegIsSet: boolean = false;
  set guestPortalReg(v: undefined | string) {
    if (v !== undefined) {
      this.guestPortalReg__I = v;
      this.guestPortalRegIsSet = true;
    } else {
      this.guestPortalReg__I = v || undefined;
      this.guestPortalRegIsSet = false;
    }
    this.changeTracker = true;
  }
  get guestPortalReg() {
    return this.guestPortalReg__I;
  }
  signoutBlockReason__I?: string = undefined;
  signoutBlockReasonIsSet: boolean = false;
  set signoutBlockReason(v: undefined | string) {
    if (v !== undefined) {
      this.signoutBlockReason__I = v;
      this.signoutBlockReasonIsSet = true;
    } else {
      this.signoutBlockReason__I = v || undefined;
      this.signoutBlockReasonIsSet = false;
    }
    this.changeTracker = true;
  }
  get signoutBlockReason() {
    return this.signoutBlockReason__I;
  }
  campFair__I?: string = undefined;
  campFairIsSet: boolean = false;
  set campFair(v: undefined | string) {
    if (v !== undefined) {
      this.campFair__I = v;
      this.campFairIsSet = true;
    } else {
      this.campFair__I = v || undefined;
      this.campFairIsSet = false;
    }
    this.changeTracker = true;
  }
  get campFair() {
    return this.campFair__I;
  }
  dataUnconfirmed__I?: string = undefined;
  dataUnconfirmedIsSet: boolean = false;
  set dataUnconfirmed(v: undefined | string) {
    if (v !== undefined) {
      this.dataUnconfirmed__I = v;
      this.dataUnconfirmedIsSet = true;
    } else {
      this.dataUnconfirmed__I = v || undefined;
      this.dataUnconfirmedIsSet = false;
    }
    this.changeTracker = true;
  }
  get dataUnconfirmed() {
    return this.dataUnconfirmed__I;
  }
  protopersonCookie__I?: string = undefined;
  protopersonCookieIsSet: boolean = false;
  set protopersonCookie(v: undefined | string) {
    if (v !== undefined) {
      this.protopersonCookie__I = v;
      this.protopersonCookieIsSet = true;
    } else {
      this.protopersonCookie__I = v || undefined;
      this.protopersonCookieIsSet = false;
    }
    this.changeTracker = true;
  }
  get protopersonCookie() {
    return this.protopersonCookie__I;
  }
  protoState__I?: string = undefined;
  protoStateIsSet: boolean = false;
  set protoState(v: undefined | string) {
    if (v !== undefined) {
      this.protoState__I = v;
      this.protoStateIsSet = true;
    } else {
      this.protoState__I = v || undefined;
      this.protoStateIsSet = false;
    }
    this.changeTracker = true;
  }
  get protoState() {
    return this.protoState__I;
  }
  memberComment__I?: string = undefined;
  memberCommentIsSet: boolean = false;
  set memberComment(v: undefined | string) {
    if (v !== undefined) {
      this.memberComment__I = v;
      this.memberCommentIsSet = true;
    } else {
      this.memberComment__I = v || undefined;
      this.memberCommentIsSet = false;
    }
    this.changeTracker = true;
  }
  get memberComment() {
    return this.memberComment__I;
  }
  slackUserId__I?: string = undefined;
  slackUserIdIsSet: boolean = false;
  set slackUserId(v: undefined | string) {
    if (v !== undefined) {
      this.slackUserId__I = v;
      this.slackUserIdIsSet = true;
    } else {
      this.slackUserId__I = v || undefined;
      this.slackUserIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get slackUserId() {
    return this.slackUserId__I;
  }
  squareCustomerId__I?: string = undefined;
  squareCustomerIdIsSet: boolean = false;
  set squareCustomerId(v: undefined | string) {
    if (v !== undefined) {
      this.squareCustomerId__I = v;
      this.squareCustomerIdIsSet = true;
    } else {
      this.squareCustomerId__I = v || undefined;
      this.squareCustomerIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get squareCustomerId() {
    return this.squareCustomerId__I;
  }
  defaultCardId__I?: string = undefined;
  defaultCardIdIsSet: boolean = false;
  set defaultCardId(v: undefined | string) {
    if (v !== undefined) {
      this.defaultCardId__I = v;
      this.defaultCardIdIsSet = true;
    } else {
      this.defaultCardId__I = v || undefined;
      this.defaultCardIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get defaultCardId() {
    return this.defaultCardId__I;
  }
  constructor(config?: PersonLegacyOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: PersonLegacyOptional,
    options?: AssignOptions,
  ): PersonLegacyTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.parentEmail &&
      this.parentEmailApplyFilter(optionsRequired.filter)
    ) {
      this.parentEmail = config.parentEmail;
      if (optionsRequired.unassign) this.parentEmailIsSet = false;
      else this.parentEmailIsSet = true;
    }
    if (
      config.incomeLevel &&
      this.incomeLevelApplyFilter(optionsRequired.filter)
    ) {
      this.incomeLevel = config.incomeLevel;
      if (optionsRequired.unassign) this.incomeLevelIsSet = false;
      else this.incomeLevelIsSet = true;
    }
    if (config.incomeAmt && this.incomeAmtApplyFilter(optionsRequired.filter)) {
      this.incomeAmt = config.incomeAmt;
      if (optionsRequired.unassign) this.incomeAmtIsSet = false;
      else this.incomeAmtIsSet = true;
    }
    if (
      config.incomeAmtRaw &&
      this.incomeAmtRawApplyFilter(optionsRequired.filter)
    ) {
      this.incomeAmtRaw = config.incomeAmtRaw;
      if (optionsRequired.unassign) this.incomeAmtRawIsSet = false;
      else this.incomeAmtRawIsSet = true;
    }
    if (config.badMail && this.badMailApplyFilter(optionsRequired.filter)) {
      this.badMail = config.badMail;
      if (optionsRequired.unassign) this.badMailIsSet = false;
      else this.badMailIsSet = true;
    }
    if (config.deceased && this.deceasedApplyFilter(optionsRequired.filter)) {
      this.deceased = config.deceased;
      if (optionsRequired.unassign) this.deceasedIsSet = false;
      else this.deceasedIsSet = true;
    }
    if (config.doNotCall && this.doNotCallApplyFilter(optionsRequired.filter)) {
      this.doNotCall = config.doNotCall;
      if (optionsRequired.unassign) this.doNotCallIsSet = false;
      else this.doNotCallIsSet = true;
    }
    if (
      config.doNotEmail &&
      this.doNotEmailApplyFilter(optionsRequired.filter)
    ) {
      this.doNotEmail = config.doNotEmail;
      if (optionsRequired.unassign) this.doNotEmailIsSet = false;
      else this.doNotEmailIsSet = true;
    }
    if (config.doNotMail && this.doNotMailApplyFilter(optionsRequired.filter)) {
      this.doNotMail = config.doNotMail;
      if (optionsRequired.unassign) this.doNotMailIsSet = false;
      else this.doNotMailIsSet = true;
    }
    if (config.employer && this.employerApplyFilter(optionsRequired.filter)) {
      this.employer = config.employer;
      if (optionsRequired.unassign) this.employerIsSet = false;
      else this.employerIsSet = true;
    }
    if (
      config.referralSource &&
      this.referralSourceApplyFilter(optionsRequired.filter)
    ) {
      this.referralSource = config.referralSource;
      if (optionsRequired.unassign) this.referralSourceIsSet = false;
      else this.referralSourceIsSet = true;
    }
    if (config.badPhone && this.badPhoneApplyFilter(optionsRequired.filter)) {
      this.badPhone = config.badPhone;
      if (optionsRequired.unassign) this.badPhoneIsSet = false;
      else this.badPhoneIsSet = true;
    }
    if (config.badEmail && this.badEmailApplyFilter(optionsRequired.filter)) {
      this.badEmail = config.badEmail;
      if (optionsRequired.unassign) this.badEmailIsSet = false;
      else this.badEmailIsSet = true;
    }
    if (
      config.referralOther &&
      this.referralOtherApplyFilter(optionsRequired.filter)
    ) {
      this.referralOther = config.referralOther;
      if (optionsRequired.unassign) this.referralOtherIsSet = false;
      else this.referralOtherIsSet = true;
    }
    if (
      config.jpAgeOverride &&
      this.jpAgeOverrideApplyFilter(optionsRequired.filter)
    ) {
      this.jpAgeOverride = config.jpAgeOverride;
      if (optionsRequired.unassign) this.jpAgeOverrideIsSet = false;
      else this.jpAgeOverrideIsSet = true;
    }
    if (config.sendAlert && this.sendAlertApplyFilter(optionsRequired.filter)) {
      this.sendAlert = config.sendAlert;
      if (optionsRequired.unassign) this.sendAlertIsSet = false;
      else this.sendAlertIsSet = true;
    }
    if (
      config.ignoreJpMinAge &&
      this.ignoreJpMinAgeApplyFilter(optionsRequired.filter)
    ) {
      this.ignoreJpMinAge = config.ignoreJpMinAge;
      if (optionsRequired.unassign) this.ignoreJpMinAgeIsSet = false;
      else this.ignoreJpMinAgeIsSet = true;
    }
    if (
      config.uapInterestedLessons &&
      this.uapInterestedLessonsApplyFilter(optionsRequired.filter)
    ) {
      this.uapInterestedLessons = config.uapInterestedLessons;
      if (optionsRequired.unassign) this.uapInterestedLessonsIsSet = false;
      else this.uapInterestedLessonsIsSet = true;
    }
    if (
      config.uapInterestedRides &&
      this.uapInterestedRidesApplyFilter(optionsRequired.filter)
    ) {
      this.uapInterestedRides = config.uapInterestedRides;
      if (optionsRequired.unassign) this.uapInterestedRidesIsSet = false;
      else this.uapInterestedRidesIsSet = true;
    }
    if (
      config.entityType &&
      this.entityTypeApplyFilter(optionsRequired.filter)
    ) {
      this.entityType = config.entityType;
      if (optionsRequired.unassign) this.entityTypeIsSet = false;
      else this.entityTypeIsSet = true;
    }
    if (config.jpTeamId && this.jpTeamIdApplyFilter(optionsRequired.filter)) {
      this.jpTeamId = config.jpTeamId;
      if (optionsRequired.unassign) this.jpTeamIdIsSet = false;
      else this.jpTeamIdIsSet = true;
    }
    if (
      config.guestPortalReg &&
      this.guestPortalRegApplyFilter(optionsRequired.filter)
    ) {
      this.guestPortalReg = config.guestPortalReg;
      if (optionsRequired.unassign) this.guestPortalRegIsSet = false;
      else this.guestPortalRegIsSet = true;
    }
    if (
      config.signoutBlockReason &&
      this.signoutBlockReasonApplyFilter(optionsRequired.filter)
    ) {
      this.signoutBlockReason = config.signoutBlockReason;
      if (optionsRequired.unassign) this.signoutBlockReasonIsSet = false;
      else this.signoutBlockReasonIsSet = true;
    }
    if (config.campFair && this.campFairApplyFilter(optionsRequired.filter)) {
      this.campFair = config.campFair;
      if (optionsRequired.unassign) this.campFairIsSet = false;
      else this.campFairIsSet = true;
    }
    if (
      config.dataUnconfirmed &&
      this.dataUnconfirmedApplyFilter(optionsRequired.filter)
    ) {
      this.dataUnconfirmed = config.dataUnconfirmed;
      if (optionsRequired.unassign) this.dataUnconfirmedIsSet = false;
      else this.dataUnconfirmedIsSet = true;
    }
    if (
      config.protopersonCookie &&
      this.protopersonCookieApplyFilter(optionsRequired.filter)
    ) {
      this.protopersonCookie = config.protopersonCookie;
      if (optionsRequired.unassign) this.protopersonCookieIsSet = false;
      else this.protopersonCookieIsSet = true;
    }
    if (
      config.protoState &&
      this.protoStateApplyFilter(optionsRequired.filter)
    ) {
      this.protoState = config.protoState;
      if (optionsRequired.unassign) this.protoStateIsSet = false;
      else this.protoStateIsSet = true;
    }
    if (
      config.memberComment &&
      this.memberCommentApplyFilter(optionsRequired.filter)
    ) {
      this.memberComment = config.memberComment;
      if (optionsRequired.unassign) this.memberCommentIsSet = false;
      else this.memberCommentIsSet = true;
    }
    if (
      config.slackUserId &&
      this.slackUserIdApplyFilter(optionsRequired.filter)
    ) {
      this.slackUserId = config.slackUserId;
      if (optionsRequired.unassign) this.slackUserIdIsSet = false;
      else this.slackUserIdIsSet = true;
    }
    if (
      config.squareCustomerId &&
      this.squareCustomerIdApplyFilter(optionsRequired.filter)
    ) {
      this.squareCustomerId = config.squareCustomerId;
      if (optionsRequired.unassign) this.squareCustomerIdIsSet = false;
      else this.squareCustomerIdIsSet = true;
    }
    if (
      config.defaultCardId &&
      this.defaultCardIdApplyFilter(optionsRequired.filter)
    ) {
      this.defaultCardId = config.defaultCardId;
      if (optionsRequired.unassign) this.defaultCardIdIsSet = false;
      else this.defaultCardIdIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): PersonLegacyTrackedI {
    const cloned = {} as PersonLegacyTrackedI;
    if (
      this.parentEmailIsSetDeep() &&
      this.parentEmailApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.parentEmailIsSet = true;
      cloned.parentEmail = this.parentEmail;
    } else {
      //cloned.parentEmailIsSet = false
    }
    if (
      this.incomeLevelIsSetDeep() &&
      this.incomeLevelApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.incomeLevelIsSet = true;
      cloned.incomeLevel = this.incomeLevel;
    } else {
      //cloned.incomeLevelIsSet = false
    }
    if (
      this.incomeAmtIsSetDeep() &&
      this.incomeAmtApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.incomeAmtIsSet = true;
      cloned.incomeAmt = this.incomeAmt;
    } else {
      //cloned.incomeAmtIsSet = false
    }
    if (
      this.incomeAmtRawIsSetDeep() &&
      this.incomeAmtRawApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.incomeAmtRawIsSet = true;
      cloned.incomeAmtRaw = this.incomeAmtRaw;
    } else {
      //cloned.incomeAmtRawIsSet = false
    }
    if (
      this.badMailIsSetDeep() &&
      this.badMailApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.badMailIsSet = true;
      cloned.badMail = this.badMail;
    } else {
      //cloned.badMailIsSet = false
    }
    if (
      this.deceasedIsSetDeep() &&
      this.deceasedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.deceasedIsSet = true;
      cloned.deceased = this.deceased;
    } else {
      //cloned.deceasedIsSet = false
    }
    if (
      this.doNotCallIsSetDeep() &&
      this.doNotCallApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.doNotCallIsSet = true;
      cloned.doNotCall = this.doNotCall;
    } else {
      //cloned.doNotCallIsSet = false
    }
    if (
      this.doNotEmailIsSetDeep() &&
      this.doNotEmailApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.doNotEmailIsSet = true;
      cloned.doNotEmail = this.doNotEmail;
    } else {
      //cloned.doNotEmailIsSet = false
    }
    if (
      this.doNotMailIsSetDeep() &&
      this.doNotMailApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.doNotMailIsSet = true;
      cloned.doNotMail = this.doNotMail;
    } else {
      //cloned.doNotMailIsSet = false
    }
    if (
      this.employerIsSetDeep() &&
      this.employerApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.employerIsSet = true;
      cloned.employer = this.employer;
    } else {
      //cloned.employerIsSet = false
    }
    if (
      this.referralSourceIsSetDeep() &&
      this.referralSourceApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.referralSourceIsSet = true;
      cloned.referralSource = this.referralSource;
    } else {
      //cloned.referralSourceIsSet = false
    }
    if (
      this.badPhoneIsSetDeep() &&
      this.badPhoneApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.badPhoneIsSet = true;
      cloned.badPhone = this.badPhone;
    } else {
      //cloned.badPhoneIsSet = false
    }
    if (
      this.badEmailIsSetDeep() &&
      this.badEmailApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.badEmailIsSet = true;
      cloned.badEmail = this.badEmail;
    } else {
      //cloned.badEmailIsSet = false
    }
    if (
      this.referralOtherIsSetDeep() &&
      this.referralOtherApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.referralOtherIsSet = true;
      cloned.referralOther = this.referralOther;
    } else {
      //cloned.referralOtherIsSet = false
    }
    if (
      this.jpAgeOverrideIsSetDeep() &&
      this.jpAgeOverrideApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.jpAgeOverrideIsSet = true;
      cloned.jpAgeOverride = this.jpAgeOverride;
    } else {
      //cloned.jpAgeOverrideIsSet = false
    }
    if (
      this.sendAlertIsSetDeep() &&
      this.sendAlertApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.sendAlertIsSet = true;
      cloned.sendAlert = this.sendAlert;
    } else {
      //cloned.sendAlertIsSet = false
    }
    if (
      this.ignoreJpMinAgeIsSetDeep() &&
      this.ignoreJpMinAgeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.ignoreJpMinAgeIsSet = true;
      cloned.ignoreJpMinAge = this.ignoreJpMinAge;
    } else {
      //cloned.ignoreJpMinAgeIsSet = false
    }
    if (
      this.uapInterestedLessonsIsSetDeep() &&
      this.uapInterestedLessonsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.uapInterestedLessonsIsSet = true;
      cloned.uapInterestedLessons = this.uapInterestedLessons;
    } else {
      //cloned.uapInterestedLessonsIsSet = false
    }
    if (
      this.uapInterestedRidesIsSetDeep() &&
      this.uapInterestedRidesApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.uapInterestedRidesIsSet = true;
      cloned.uapInterestedRides = this.uapInterestedRides;
    } else {
      //cloned.uapInterestedRidesIsSet = false
    }
    if (
      this.entityTypeIsSetDeep() &&
      this.entityTypeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.entityTypeIsSet = true;
      cloned.entityType = this.entityType;
    } else {
      //cloned.entityTypeIsSet = false
    }
    if (
      this.jpTeamIdIsSetDeep() &&
      this.jpTeamIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.jpTeamIdIsSet = true;
      cloned.jpTeamId = this.jpTeamId;
    } else {
      //cloned.jpTeamIdIsSet = false
    }
    if (
      this.guestPortalRegIsSetDeep() &&
      this.guestPortalRegApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.guestPortalRegIsSet = true;
      cloned.guestPortalReg = this.guestPortalReg;
    } else {
      //cloned.guestPortalRegIsSet = false
    }
    if (
      this.signoutBlockReasonIsSetDeep() &&
      this.signoutBlockReasonApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.signoutBlockReasonIsSet = true;
      cloned.signoutBlockReason = this.signoutBlockReason;
    } else {
      //cloned.signoutBlockReasonIsSet = false
    }
    if (
      this.campFairIsSetDeep() &&
      this.campFairApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.campFairIsSet = true;
      cloned.campFair = this.campFair;
    } else {
      //cloned.campFairIsSet = false
    }
    if (
      this.dataUnconfirmedIsSetDeep() &&
      this.dataUnconfirmedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.dataUnconfirmedIsSet = true;
      cloned.dataUnconfirmed = this.dataUnconfirmed;
    } else {
      //cloned.dataUnconfirmedIsSet = false
    }
    if (
      this.protopersonCookieIsSetDeep() &&
      this.protopersonCookieApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.protopersonCookieIsSet = true;
      cloned.protopersonCookie = this.protopersonCookie;
    } else {
      //cloned.protopersonCookieIsSet = false
    }
    if (
      this.protoStateIsSetDeep() &&
      this.protoStateApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.protoStateIsSet = true;
      cloned.protoState = this.protoState;
    } else {
      //cloned.protoStateIsSet = false
    }
    if (
      this.memberCommentIsSetDeep() &&
      this.memberCommentApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.memberCommentIsSet = true;
      cloned.memberComment = this.memberComment;
    } else {
      //cloned.memberCommentIsSet = false
    }
    if (
      this.slackUserIdIsSetDeep() &&
      this.slackUserIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.slackUserIdIsSet = true;
      cloned.slackUserId = this.slackUserId;
    } else {
      //cloned.slackUserIdIsSet = false
    }
    if (
      this.squareCustomerIdIsSetDeep() &&
      this.squareCustomerIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.squareCustomerIdIsSet = true;
      cloned.squareCustomerId = this.squareCustomerId;
    } else {
      //cloned.squareCustomerIdIsSet = false
    }
    if (
      this.defaultCardIdIsSetDeep() &&
      this.defaultCardIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.defaultCardIdIsSet = true;
      cloned.defaultCardId = this.defaultCardId;
    } else {
      //cloned.defaultCardIdIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): PersonLegacyTrackedI {
    if (!this.parentEmailApplyFilter(filter)) this.parentEmailIsSet = false;

    if (!this.incomeLevelApplyFilter(filter)) this.incomeLevelIsSet = false;

    if (!this.incomeAmtApplyFilter(filter)) this.incomeAmtIsSet = false;

    if (!this.incomeAmtRawApplyFilter(filter)) this.incomeAmtRawIsSet = false;

    if (!this.badMailApplyFilter(filter)) this.badMailIsSet = false;

    if (!this.deceasedApplyFilter(filter)) this.deceasedIsSet = false;

    if (!this.doNotCallApplyFilter(filter)) this.doNotCallIsSet = false;

    if (!this.doNotEmailApplyFilter(filter)) this.doNotEmailIsSet = false;

    if (!this.doNotMailApplyFilter(filter)) this.doNotMailIsSet = false;

    if (!this.employerApplyFilter(filter)) this.employerIsSet = false;

    if (!this.referralSourceApplyFilter(filter))
      this.referralSourceIsSet = false;

    if (!this.badPhoneApplyFilter(filter)) this.badPhoneIsSet = false;

    if (!this.badEmailApplyFilter(filter)) this.badEmailIsSet = false;

    if (!this.referralOtherApplyFilter(filter)) this.referralOtherIsSet = false;

    if (!this.jpAgeOverrideApplyFilter(filter)) this.jpAgeOverrideIsSet = false;

    if (!this.sendAlertApplyFilter(filter)) this.sendAlertIsSet = false;

    if (!this.ignoreJpMinAgeApplyFilter(filter))
      this.ignoreJpMinAgeIsSet = false;

    if (!this.uapInterestedLessonsApplyFilter(filter))
      this.uapInterestedLessonsIsSet = false;

    if (!this.uapInterestedRidesApplyFilter(filter))
      this.uapInterestedRidesIsSet = false;

    if (!this.entityTypeApplyFilter(filter)) this.entityTypeIsSet = false;

    if (!this.jpTeamIdApplyFilter(filter)) this.jpTeamIdIsSet = false;

    if (!this.guestPortalRegApplyFilter(filter))
      this.guestPortalRegIsSet = false;

    if (!this.signoutBlockReasonApplyFilter(filter))
      this.signoutBlockReasonIsSet = false;

    if (!this.campFairApplyFilter(filter)) this.campFairIsSet = false;

    if (!this.dataUnconfirmedApplyFilter(filter))
      this.dataUnconfirmedIsSet = false;

    if (!this.protopersonCookieApplyFilter(filter))
      this.protopersonCookieIsSet = false;

    if (!this.protoStateApplyFilter(filter)) this.protoStateIsSet = false;

    if (!this.memberCommentApplyFilter(filter)) this.memberCommentIsSet = false;

    if (!this.slackUserIdApplyFilter(filter)) this.slackUserIdIsSet = false;

    if (!this.squareCustomerIdApplyFilter(filter))
      this.squareCustomerIdIsSet = false;

    if (!this.defaultCardIdApplyFilter(filter)) this.defaultCardIdIsSet = false;

    return this;
  }
  parentEmailApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonLegacyMeta.parentEmail,
      PersonLegacyMeta,
      this.parentEmail,
      this,
    );
  }
  parentEmailIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.parentEmailIsSet && this.parentEmailApplyFilter(filter))
      return true;

    return false;
  }
  incomeLevelApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonLegacyMeta.incomeLevel,
      PersonLegacyMeta,
      this.incomeLevel,
      this,
    );
  }
  incomeLevelIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.incomeLevelIsSet && this.incomeLevelApplyFilter(filter))
      return true;

    return false;
  }
  incomeAmtApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonLegacyMeta.incomeAmt,
      PersonLegacyMeta,
      this.incomeAmt,
      this,
    );
  }
  incomeAmtIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.incomeAmtIsSet && this.incomeAmtApplyFilter(filter)) return true;

    return false;
  }
  incomeAmtRawApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonLegacyMeta.incomeAmtRaw,
      PersonLegacyMeta,
      this.incomeAmtRaw,
      this,
    );
  }
  incomeAmtRawIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.incomeAmtRawIsSet && this.incomeAmtRawApplyFilter(filter))
      return true;

    return false;
  }
  badMailApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonLegacyMeta.badMail,
      PersonLegacyMeta,
      this.badMail,
      this,
    );
  }
  badMailIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.badMailIsSet && this.badMailApplyFilter(filter)) return true;

    return false;
  }
  deceasedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonLegacyMeta.deceased,
      PersonLegacyMeta,
      this.deceased,
      this,
    );
  }
  deceasedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.deceasedIsSet && this.deceasedApplyFilter(filter)) return true;

    return false;
  }
  doNotCallApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonLegacyMeta.doNotCall,
      PersonLegacyMeta,
      this.doNotCall,
      this,
    );
  }
  doNotCallIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.doNotCallIsSet && this.doNotCallApplyFilter(filter)) return true;

    return false;
  }
  doNotEmailApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonLegacyMeta.doNotEmail,
      PersonLegacyMeta,
      this.doNotEmail,
      this,
    );
  }
  doNotEmailIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.doNotEmailIsSet && this.doNotEmailApplyFilter(filter)) return true;

    return false;
  }
  doNotMailApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonLegacyMeta.doNotMail,
      PersonLegacyMeta,
      this.doNotMail,
      this,
    );
  }
  doNotMailIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.doNotMailIsSet && this.doNotMailApplyFilter(filter)) return true;

    return false;
  }
  employerApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonLegacyMeta.employer,
      PersonLegacyMeta,
      this.employer,
      this,
    );
  }
  employerIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.employerIsSet && this.employerApplyFilter(filter)) return true;

    return false;
  }
  referralSourceApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonLegacyMeta.referralSource,
      PersonLegacyMeta,
      this.referralSource,
      this,
    );
  }
  referralSourceIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.referralSourceIsSet && this.referralSourceApplyFilter(filter))
      return true;

    return false;
  }
  badPhoneApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonLegacyMeta.badPhone,
      PersonLegacyMeta,
      this.badPhone,
      this,
    );
  }
  badPhoneIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.badPhoneIsSet && this.badPhoneApplyFilter(filter)) return true;

    return false;
  }
  badEmailApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonLegacyMeta.badEmail,
      PersonLegacyMeta,
      this.badEmail,
      this,
    );
  }
  badEmailIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.badEmailIsSet && this.badEmailApplyFilter(filter)) return true;

    return false;
  }
  referralOtherApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonLegacyMeta.referralOther,
      PersonLegacyMeta,
      this.referralOther,
      this,
    );
  }
  referralOtherIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.referralOtherIsSet && this.referralOtherApplyFilter(filter))
      return true;

    return false;
  }
  jpAgeOverrideApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonLegacyMeta.jpAgeOverride,
      PersonLegacyMeta,
      this.jpAgeOverride,
      this,
    );
  }
  jpAgeOverrideIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.jpAgeOverrideIsSet && this.jpAgeOverrideApplyFilter(filter))
      return true;

    return false;
  }
  sendAlertApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonLegacyMeta.sendAlert,
      PersonLegacyMeta,
      this.sendAlert,
      this,
    );
  }
  sendAlertIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.sendAlertIsSet && this.sendAlertApplyFilter(filter)) return true;

    return false;
  }
  ignoreJpMinAgeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonLegacyMeta.ignoreJpMinAge,
      PersonLegacyMeta,
      this.ignoreJpMinAge,
      this,
    );
  }
  ignoreJpMinAgeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.ignoreJpMinAgeIsSet && this.ignoreJpMinAgeApplyFilter(filter))
      return true;

    return false;
  }
  uapInterestedLessonsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonLegacyMeta.uapInterestedLessons,
      PersonLegacyMeta,
      this.uapInterestedLessons,
      this,
    );
  }
  uapInterestedLessonsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.uapInterestedLessonsIsSet &&
      this.uapInterestedLessonsApplyFilter(filter)
    )
      return true;

    return false;
  }
  uapInterestedRidesApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonLegacyMeta.uapInterestedRides,
      PersonLegacyMeta,
      this.uapInterestedRides,
      this,
    );
  }
  uapInterestedRidesIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.uapInterestedRidesIsSet &&
      this.uapInterestedRidesApplyFilter(filter)
    )
      return true;

    return false;
  }
  entityTypeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonLegacyMeta.entityType,
      PersonLegacyMeta,
      this.entityType,
      this,
    );
  }
  entityTypeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.entityTypeIsSet && this.entityTypeApplyFilter(filter)) return true;

    return false;
  }
  jpTeamIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonLegacyMeta.jpTeamId,
      PersonLegacyMeta,
      this.jpTeamId,
      this,
    );
  }
  jpTeamIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.jpTeamIdIsSet && this.jpTeamIdApplyFilter(filter)) return true;

    return false;
  }
  guestPortalRegApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonLegacyMeta.guestPortalReg,
      PersonLegacyMeta,
      this.guestPortalReg,
      this,
    );
  }
  guestPortalRegIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.guestPortalRegIsSet && this.guestPortalRegApplyFilter(filter))
      return true;

    return false;
  }
  signoutBlockReasonApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonLegacyMeta.signoutBlockReason,
      PersonLegacyMeta,
      this.signoutBlockReason,
      this,
    );
  }
  signoutBlockReasonIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.signoutBlockReasonIsSet &&
      this.signoutBlockReasonApplyFilter(filter)
    )
      return true;

    return false;
  }
  campFairApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonLegacyMeta.campFair,
      PersonLegacyMeta,
      this.campFair,
      this,
    );
  }
  campFairIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.campFairIsSet && this.campFairApplyFilter(filter)) return true;

    return false;
  }
  dataUnconfirmedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonLegacyMeta.dataUnconfirmed,
      PersonLegacyMeta,
      this.dataUnconfirmed,
      this,
    );
  }
  dataUnconfirmedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.dataUnconfirmedIsSet && this.dataUnconfirmedApplyFilter(filter))
      return true;

    return false;
  }
  protopersonCookieApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonLegacyMeta.protopersonCookie,
      PersonLegacyMeta,
      this.protopersonCookie,
      this,
    );
  }
  protopersonCookieIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.protopersonCookieIsSet &&
      this.protopersonCookieApplyFilter(filter)
    )
      return true;

    return false;
  }
  protoStateApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonLegacyMeta.protoState,
      PersonLegacyMeta,
      this.protoState,
      this,
    );
  }
  protoStateIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.protoStateIsSet && this.protoStateApplyFilter(filter)) return true;

    return false;
  }
  memberCommentApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonLegacyMeta.memberComment,
      PersonLegacyMeta,
      this.memberComment,
      this,
    );
  }
  memberCommentIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.memberCommentIsSet && this.memberCommentApplyFilter(filter))
      return true;

    return false;
  }
  slackUserIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonLegacyMeta.slackUserId,
      PersonLegacyMeta,
      this.slackUserId,
      this,
    );
  }
  slackUserIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.slackUserIdIsSet && this.slackUserIdApplyFilter(filter))
      return true;

    return false;
  }
  squareCustomerIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonLegacyMeta.squareCustomerId,
      PersonLegacyMeta,
      this.squareCustomerId,
      this,
    );
  }
  squareCustomerIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.squareCustomerIdIsSet && this.squareCustomerIdApplyFilter(filter))
      return true;

    return false;
  }
  defaultCardIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonLegacyMeta.defaultCardId,
      PersonLegacyMeta,
      this.defaultCardId,
      this,
    );
  }
  defaultCardIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.defaultCardIdIsSet && this.defaultCardIdApplyFilter(filter))
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.parentEmailIsSetDeep(filter)) return true;
    if (this.incomeLevelIsSetDeep(filter)) return true;
    if (this.incomeAmtIsSetDeep(filter)) return true;
    if (this.incomeAmtRawIsSetDeep(filter)) return true;
    if (this.badMailIsSetDeep(filter)) return true;
    if (this.deceasedIsSetDeep(filter)) return true;
    if (this.doNotCallIsSetDeep(filter)) return true;
    if (this.doNotEmailIsSetDeep(filter)) return true;
    if (this.doNotMailIsSetDeep(filter)) return true;
    if (this.employerIsSetDeep(filter)) return true;
    if (this.referralSourceIsSetDeep(filter)) return true;
    if (this.badPhoneIsSetDeep(filter)) return true;
    if (this.badEmailIsSetDeep(filter)) return true;
    if (this.referralOtherIsSetDeep(filter)) return true;
    if (this.jpAgeOverrideIsSetDeep(filter)) return true;
    if (this.sendAlertIsSetDeep(filter)) return true;
    if (this.ignoreJpMinAgeIsSetDeep(filter)) return true;
    if (this.uapInterestedLessonsIsSetDeep(filter)) return true;
    if (this.uapInterestedRidesIsSetDeep(filter)) return true;
    if (this.entityTypeIsSetDeep(filter)) return true;
    if (this.jpTeamIdIsSetDeep(filter)) return true;
    if (this.guestPortalRegIsSetDeep(filter)) return true;
    if (this.signoutBlockReasonIsSetDeep(filter)) return true;
    if (this.campFairIsSetDeep(filter)) return true;
    if (this.dataUnconfirmedIsSetDeep(filter)) return true;
    if (this.protopersonCookieIsSetDeep(filter)) return true;
    if (this.protoStateIsSetDeep(filter)) return true;
    if (this.memberCommentIsSetDeep(filter)) return true;
    if (this.slackUserIdIsSetDeep(filter)) return true;
    if (this.squareCustomerIdIsSetDeep(filter)) return true;
    if (this.defaultCardIdIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
